import gql from 'graphql-tag'

export default gql`
  query SmartRateQuery($loanId: Int!) {
    loan(rid: $loanId) {
      rid
      needsRedecision
      lastPredictionDataPermutation
      smartRate
      predictionResults {
        riskRating
        smartRate
        id
        topAttrs
        createdAt
        predictionModel {
          dataPermutation
          version
          type
          scope
        }
      }
      product {
        name
        lenderKey
        finalDecision
      }
    }
  }
`
